/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Web_Present_4Inputs */



/**
* | output |
* | --- |
* | "checking the web" |
*
* @param {Chat_Summary_Web_Present_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_web_present_4 = /** @type {((inputs?: Chat_Summary_Web_Present_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Web_Present_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("schaue im Web nach")
	return /** @type {LocalizedString} */ ("checking the web")
});